/* eslint-disable @svg/comment/comment-before-functions */

import { useEffect } from 'react';

type ScrollHandlerProps = {
  element: HTMLElement | React.RefObject<HTMLElement>;
  isScroll?: boolean;
  interval?: number;
  distance?: number;
  delay?: number;
  callback?: (scrollLeft: number) => void;
};

const useScrollByWheel = ({
  element,
  isScroll = true,
  interval = 50,
  distance = 10,
  delay = 50,
  callback
}: ScrollHandlerProps) => {
  const current = {
    isScroll: isScroll,
    scrollTime: Date.now(),
    interval: interval,
    distance: distance,
    delay: delay
  };
  let timer: NodeJS.Timeout | null;

  const wheel = (event: WheelEvent) => {
    const scrollBox = element instanceof HTMLElement ? element : (element.current as HTMLElement);
    if (scrollBox) {
      event.preventDefault();
      scrollBox.scrollLeft += event.deltaY;
      callback && callback(scrollBox.scrollLeft);
    }
  };

  const onWheel = (e: WheelEvent) => {
    const time = Date.now();
    const y = e.deltaY;

    if (current.scrollTime) {
      if (time - current.scrollTime > current.interval && Math.abs(y) >= current.distance) {
        wheel(e);
        timer && clearTimeout(timer as NodeJS.Timeout);
        current.isScroll = false;
        current.scrollTime = time;
      }
    }

    if (current.isScroll) {
      wheel(e);
      current.scrollTime = Date.now();
      current.isScroll = false;
    }

    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      current.isScroll = true;
    }, current.delay);
  };

  useEffect(() => {
    const scrollBox = element instanceof HTMLElement ? element : (element.current as HTMLElement);
    if (scrollBox) {
      scrollBox.addEventListener('wheel', onWheel);
    }

    return () => {
      if (scrollBox) {
        scrollBox.removeEventListener('wheel', onWheel);
      }
    };
  }, [element, onWheel]);
};

export default useScrollByWheel;
